// extracted by mini-css-extract-plugin
export var standaloneTable = "_fm-0";
export var withExtraHeader = "_fm-1";